// extracted by mini-css-extract-plugin
module.exports = {"SwitchCheckbox":"SwitchToggle_SwitchCheckbox__3A6KJ","SwitchLabel":"SwitchToggle_SwitchLabel__2gA3S","SwitchButton":"SwitchToggle_SwitchButton__25SPh"};